<template>
  <slot
    v-if="hasError"
    name="error"
    :reset="reset"
    :err="errorCaptured?.err"
    :instance="errorCaptured?.instance"
    :info="errorCaptured?.info"
  >
    <div class="error-view container">
      <CardErro
        message="Caso o erro persista, entre em contato com nosso atendimento"
        button-text="Voltar à página inicial"
        componente-pai="ErrorBoundary-generico"
        @retry="handleRetry"
      />
    </div>
  </slot>
  <slot v-else />
</template>

<script lang="ts">
import {
  defineComponent,
  onErrorCaptured,
  ref,
  ComponentPublicInstance,
} from 'vue';

import CardErro from '@/components/CardErro.vue';
import { acertoClickVoltarPaginaInicialErroGenerico } from '@/modules/events/acerto';

interface ErrorCaptured {
  err: unknown;
  instance: ComponentPublicInstance | null;
  info: string;
}

export default defineComponent({
  components: { CardErro },
  props: {
    stopPropagation: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['error'],
  setup(props, { emit }) {
    const hasError = ref(false);

    const errorCaptured = ref<ErrorCaptured>();

    const reset = () => {
      hasError.value = false;
      logger.tracker.action('resetou ErrorBoundary');
    };

    const handleRetry = () => {
      reset();
      acertoClickVoltarPaginaInicialErroGenerico();
    };

    onErrorCaptured((err, instance, info) => {
      hasError.value = true;

      const newErrorCaptured = { err, instance, info };
      errorCaptured.value = newErrorCaptured;
      emit('error', newErrorCaptured);

      return !props.stopPropagation;
    });

    return {
      hasError,
      errorCaptured,
      reset,
      handleRetry,
    };
  },
});
</script>

<style scoped lang="scss">
.error-view {
  padding: 24px;
  max-width: 800px;
}
</style>
